'use es6';

import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { batchScheduler } from 'batch-promise';
import { makeCachedScheduler } from './makeCachedScheduler';
const BASE_ASSOCIATIONS_URL = 'associations/v1/associations-frontend/single-portal-queries';
const MAX_REQUEST_SIZE = 200;
export const makeRequestKey = ({
  associationCategory,
  associationTypeId,
  objectId
}) => `${associationCategory}:${associationTypeId}:${objectId}`;
export const makeRequestBody = calls => {
  const portalId = PortalIdParser.get();
  return Object.values(calls).map(({
    associationCategory,
    associationTypeId,
    objectId
  }) => ({
    portalId,
    fromObjectId: objectId,
    associationCategory,
    associationTypeId,
    limit: 100,
    offset: 0
  }));
};
const associatedObjectIdsScheduler = batchScheduler().read().identity(makeRequestKey).partition(() => 'associatedObjectIds').execute(calls => http.post(BASE_ASSOCIATIONS_URL, {
  data: makeRequestBody(calls)
}).then(response => response.reduce((acc, {
  associationTypeId,
  category,
  fromObjectId,
  results
}) => {
  acc[makeRequestKey({
    associationCategory: category,
    associationTypeId,
    objectId: fromObjectId
  })] = results;
  return acc;
}, {}))).extract(({
  response,
  identity
}) => response[identity]).chunkSize(MAX_REQUEST_SIZE).window(200);
export const AssociationsBatchRequestClient = makeCachedScheduler(associatedObjectIdsScheduler);
export const __resetAssociationsBatchCache = () => {
  AssociationsBatchRequestClient.clearCache();
};